import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { addOeEM, getOEMById ,baseURL} from '../../utils/oem';  
import { Link, useNavigate,useLocation } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import BreadCrumb from "../../Components/Common/BreadCrumb";
const SimpleCompany = () => {
    const location = useLocation(); // Get current location
    const searchParams = new URLSearchParams(location.search);
    const companyId = searchParams.get("companyId");  
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const dateFormat = (d) => {
    //let d = new Date()
    return (( d.getFullYear()).toString()+ '-' + d.getMonth() + '-' + d.getDate() );
  };

  useEffect(() => {
    const fetchCompanyData = async () => {
        try {
        const response = await getOEMById(companyId); 
        if(response.status==200){  
            setLoading(false);
            setCompanyData(response.data.data);
        }else {
            errornotify(response.message)  
          }
        } catch (error) {
        console.error('Error fetching company data:', error);
        }
    };
    fetchCompanyData();
  }, []);

  if (loading) {
    return <div className="page-content">Loading company information...</div>;
  }

  if (!companyData) {
    return <div className="page-content">Error loading company data</div>;
  }

  return (
    <div className="page-content">
      <Container fluid>
      <BreadCrumb title='Company Overview' pageTitle="Ecommerce" />
      <ToastContainer />  
            <div className="d-flex">
                <div className="d-flex justify-content-between w-100 mb-5">
                    <h2>{companyData.oem_companyname}</h2>
                    <div className="d-flex align-items-center"> {/* 新增对齐容器 */}
                        <div className="flex-shrink-0">
                            <Link   to={`/company-setting?companyId=${companyId}`} className="btn btn-success">
                                <i className="ri-edit-box-line align-bottom"></i> Edit
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* 基本信息 */}
            <Row className="mb-4">
              
              {companyData.logo_image?  
                  <Col md={6}>
                  <div className="d-flex align-items-center mb-3"> 
                      <div>
                      <p className="mb-0">Logo Image</p>
                      <img src={`${baseURL}/file/oem/image/${companyData.logo_image}`} alt="Logo" className="rounded" width="120" />
                      </div>
                  </div>
                  </Col> 
              :""}
              {companyData.storefront_image? 
                  <Col md={6}>
                  <div className="d-flex align-items-center mb-3"> 
                      <div>
                      <p className="mb-0">Store Image</p>
                      <img
                    src={`${baseURL}/file/oem/image/${companyData.storefront_image}`}
                    alt="Storefront"
                    className="img-fluid rounded"
                    style={{ maxHeight: '300px' }}
                  /> 
                      </div>
                  </div>
                </Col> 
              :""}
              <Col md={6}>
                <div className="d-flex align-items-center mb-3">
                    <i className="ri-building-line fs-4 me-3"></i>
                    <div>
                    <p className="mb-0">Company Name</p>
                    <h5>{companyData.oem_companyname}</h5>
                    </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                    <i className="ri-store-2-line fs-4 me-3"></i>
                    <div>
                    <p className="mb-0">Brand Name</p>
                    <h5>{companyData.oem_brandname}</h5>
                    </div>
                </div>
                </Col>
                <Col md={6}>
                <div className="d-flex align-items-center mb-3">
                    <i className="ri-profile-line fs-4 me-3"></i>
                    <div>
                    <p className="mb-0">Tax ID</p>
                    <h5>{companyData.tax_id}</h5>
                    </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                    <i className="ri-money-dollar-circle-line fs-4 me-3"></i>
                    <div>
                    <p className="mb-0">Currency</p>
                    <h5>{companyData.currency}</h5>
                    </div>
                </div>
                </Col>
            </Row>

            {/* 联系信息 */}
            <div className="border-top pt-4 mb-4">
                <h5 className="mb-3">Contact Information</h5>
                <Row>
                <Col md={4}>
                    <p className="text-muted mb-1">Contact Person</p>
                    <h6>{companyData.contact_name}</h6>
                </Col>
                <Col md={4}>
                    <p className="text-muted mb-1">Email</p>
                    <h6>{companyData.contact_email}</h6>
                </Col>
                <Col md={4}>
                    <p className="text-muted mb-1">Phone</p>
                    <h6>{companyData.contact_phone}</h6>
                </Col>
                </Row>
            </div>

            {/* 地址信息 */}
            <div className="border-top pt-4 mb-4">
                <h5 className="mb-3">Location</h5>
                <Row>
                <Col md={6}>
                    <p className="text-muted mb-1">Address</p>
                    <h6>{companyData.street}, {companyData.city}</h6>
                    <h6>{companyData.province}, {companyData.country}</h6>
                </Col>
                <Col md={6}>
                    <p className="text-muted mb-1">ZIP Code</p>
                    <h6>{companyData.zipcode}</h6>
                </Col>
                </Row>
            </div>

            {/* 合同信息 */}
            <div className="border-top pt-4">
                <h5 className="mb-3">Contract Period</h5>
                <Row>
                <Col md={6}>
                    <p className="text-muted mb-1">Start Date</p>
                    <h6>{dateFormat(new Date(companyData.contract_start), 'yyyy-MM-dd')}</h6>
                </Col>
                <Col md={6}>
                    <p className="text-muted mb-1">End Date</p>
                    <h6>{dateFormat(new Date(companyData.contract_end), 'yyyy-MM-dd')}</h6>
                </Col>
                </Row>
            </div> 
      </Container>
    </div>
  );
};

export default SimpleCompany;